import { useState } from "react";
import { CASE_STUDIES } from "@/lib/site-data";
import { MapPin, Calendar } from "lucide-react";

export const CaseStudies = () => {
  const [active, setActive] = useState(CASE_STUDIES[0].id);
  const current = CASE_STUDIES.find((c) => c.id === active) ?? CASE_STUDIES[0];

  return (
    <section
      id="projects"
      data-testid="case-studies-section"
      className="bg-slate-950 text-white py-24 md:py-32 relative grain"
    >
      <div className="container-narrow">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-6">
            <div className="overline text-emerald-400 mb-5">— Selected work</div>
            <h2 className="font-serif text-3xl md:text-5xl tracking-tight leading-tight text-white">
              Programmes our clients<br />stake their reputation on.
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 flex items-end">
            <p className="text-slate-300 text-base md:text-lg leading-relaxed">
              A small selection from {new Date().getFullYear() - 1}–{new Date().getFullYear()}.
              Detailed case studies — including references — are shared under NDA on request.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-4 flex flex-col border-t border-white/10">
            {CASE_STUDIES.map((c) => {
              const isActive = c.id === active;
              return (
                <button
                  key={c.id}
                  data-testid={`case-tab-${c.id}`}
                  onClick={() => setActive(c.id)}
                  className={`text-left border-b border-white/10 py-6 transition-colors ${
                    isActive ? "text-white" : "text-slate-400 hover:text-white"
                  }`}
                >
                  <div className="flex items-baseline justify-between mb-2">
                    <span className="overline text-emerald-400">
                      {c.industry}
                    </span>
                    <span className="text-xs text-slate-500">{c.year}</span>
                  </div>
                  <div className="font-serif text-lg md:text-xl tracking-tight leading-snug">
                    {c.title}
                  </div>
                  <div
                    className={`mt-3 h-px transition-all ${
                      isActive ? "bg-emerald-400 w-24" : "bg-transparent w-0"
                    }`}
                  />
                </button>
              );
            })}
          </div>

          <div
            key={current.id}
            data-testid="case-detail"
            className="md:col-span-8 animate-fade-up"
          >
            <div className="overflow-hidden border border-white/10">
              <img
                src={current.image}
                alt={current.title}
                className="w-full h-64 md:h-96 object-cover"
              />
            </div>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-12 gap-6">
              <div className="md:col-span-7">
                <h3 className="font-serif text-2xl md:text-3xl tracking-tight leading-tight text-white">
                  {current.title}
                </h3>
                <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-slate-400">
                  <span className="flex items-center gap-1.5">
                    <MapPin size={12} strokeWidth={1.5} /> {current.location}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <Calendar size={12} strokeWidth={1.5} /> {current.year}
                  </span>
                </div>
                <p className="mt-6 text-slate-300 text-sm md:text-base leading-relaxed">
                  {current.summary}
                </p>
              </div>
              <div className="md:col-span-5 flex flex-col gap-4 md:border-l md:border-white/10 md:pl-8">
                {current.metrics.map((m) => (
                  <div key={m.label} className="flex items-baseline justify-between">
                    <span className="overline text-slate-400 max-w-[60%]">
                      {m.label}
                    </span>
                    <span className="font-serif text-2xl md:text-3xl text-emerald-300">
                      {m.value}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
